<template>

    <b-modal ref="my-modal" class="modal" :modal-class="mClass" :title="title">

       <component ref="customComponents" @hideModel="hide" :data="data" :is="component"></component>

        <template  v-slot:modal-footer="{cancel}">
            <div class="modal__footer--left">
                <b-button variant="-gray" @click="cancel()">
                    {{$t('buttons.cancel')}}
                </b-button>
            </div>
            <div class="modal__footer--right">
                <b-button variant="-primary" @click="ok">
                    {{$t('printers.item.buttons.saveChanges')}}
                </b-button>
            </div>
        </template>
    </b-modal>
</template>

<script>
  import FilesUpload from "./apps/upload/FilesUpload";
  import FileEdit from "./files/modal/FileEdit";
  export default {
    name: "TestPopUP",
    components: {FilesUpload, FileEdit},
    data(){
      return {
        title: 'title',
        component: 'Footer',
        data: false,
        footer: false,
        mClass: null
      }
    },
    methods: {
      init({title, component, data, footer, mClass}){
        this.title = title;
        this.component = component;
        this.data = data;
        this.footer = footer;
        this.mClass = mClass;

        this.$refs['my-modal'].show()
      },
      hide(){
        this.$refs['my-modal'].hide()
      },
      ok(){
        this.$refs['customComponents'].ok()
      },

    }
  }
</script>

<style scoped>

</style>
